export default {
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    searchTerm: '',
  }),
  computed: {
    filteredList() {
      const term = this.searchTerm.trim().toLowerCase();
      if (term.length === 0) {
        return this.list;
      }

      return this.list.filter(i => this.getSearchName(i).toLowerCase().includes(term));
    },
  },
  methods: {
    getSearchName(item) {
      return item.name;
    },
    onSelect(item) {
      if (this.isDisabled(item)) {
        return;
      }
      this.$emit('update:modelValue', item.external_id);
    },
  },
};
